import React, { useEffect } from 'react';
import { Image, Linking } from 'react-native';
import type { BEEventProps, CompanyProps } from '../../types';
import { Button, Text, View } from '../../Components/Themed';
import { useColors } from '../../constants/useColors';

type CompanyCardProps = {
    company:CompanyProps,
    width:number,
    onEvent?:(be_event:BEEventProps) => void,
    onSelectCompany?:(company:CompanyProps) => void
}
const MAX_IMAGE_WIDTH = 175

const CompanyCard = ({company, width, onEvent, onSelectCompany}:CompanyCardProps) => {
    const Colors = useColors();
    //const company_ref = useRef(null)
    const isInViewport = false//useIsInViewport(company_ref);
    useEffect(() => {
        if(isInViewport && onEvent){
            let be_event:BEEventProps = {
                event_name:'company_view',
                event_data: {
                    view_type: 'engage',
                    view_location: 'header',
                },
                level:2
            }
            
            onEvent(be_event)
        }
    },[isInViewport])

    const image_width = width > MAX_IMAGE_WIDTH ? MAX_IMAGE_WIDTH : width

    let description = company.company_description
    if(description.length > 50){
        description = `${description.slice(0, 50)}...`
    }

    return (
        <Button float style={{ flexGrow:1, width:image_width, borderRadius:8, padding:0, backgroundColor:company.brand_primary ?? Colors.absolutes.shades.shade100, borderColor:Colors.absolutes.shades.shade100}}
        onPress={() => {
            if(onSelectCompany){ return onSelectCompany(company) }
            if(company.company_url){ Linking.openURL(company.company_url) }
            return
        }}>
            <View transparent style={{ padding:10, flexDirection:'row', alignItems:'center' }}>
                <View transparent style={{ flexShrink:1  }}>
                    <Text size={14} theme='h2' color={Colors.text.white} weight='bold'>{company.company_name}</Text>
                </View>
            </View>
            <View style={{ flexGrow:1, borderBottomRightRadius:8, borderBottomLeftRadius:8, backgroundColor:Colors.absolutes.shades.shade100 }}>
                <Image
                    source={{ uri: company.company_image?.url }}
                    style={{ height: image_width, width:image_width - 2, borderBottomRightRadius:8, borderBottomLeftRadius:8}}
                    resizeMode='contain'
                />
                 <View style={{ position:'absolute', backgroundColor:Colors.text.white, bottom:0, left:0, right:0, padding:10, borderBottomRightRadius:8, borderBottomLeftRadius:8 }}>
                    <Text theme='h2' color={Colors.absolutes.brand.midnight}>{description}</Text>
                </View>
            </View>
        </Button>
    )
}

export default CompanyCard